import { motion } from "motion/react";
import { Effects, FadeMethod, MoveMethod } from "../../types";
import { DEFAULT_ANIMATION_DURATION_SECONDS } from "../../constants";
import { getMotionEasing } from "./easingMap";
import { BASE_PREVIEW_DELAY } from "./constants";
import { counterRotateOffset } from "./counterRotateOffset";

interface EnterFromWrapperProps {
  children: React.ReactNode;
  effect: Effects;
  previewWidth: number;
  previewHeight: number;
  duration?: number;
  delay?: number;
  method?: MoveMethod | FadeMethod;
  rotation?: number;
}

export const EnterFromWrapper: React.FC<EnterFromWrapperProps> = ({
  children,
  effect,
  previewWidth,
  previewHeight,
  duration = DEFAULT_ANIMATION_DURATION_SECONDS,
  delay = 0,
  method,
  rotation = 0,
}) => {
  const offset = {
    x: 0,
    y: 0,
  };
  if (effect === Effects.enterFromTop) offset.y = -previewHeight;
  if (effect === Effects.enterFromBottom) offset.y = previewHeight;
  if (effect === Effects.enterFromLeft) offset.x = -previewWidth;
  if (effect === Effects.enterFromRight) offset.x = previewWidth;

  // Keep the slide-in direction axis-aligned on screen even when the item is
  // rotated (the wrapper sits inside the item's rotation transform).
  const initialPos = counterRotateOffset(offset, rotation);

  return (
    <motion.div
      key={effect}
      initial={initialPos}
      animate={{ x: 0, y: 0 }}
      transition={{
        duration,
        delay: BASE_PREVIEW_DELAY + delay,
        ease: getMotionEasing(method),
      }}
      style={{ width: "100%", height: "100%" }}
    >
      {children}
    </motion.div>
  );
};
